import $ from 'jquery';
import {
	publish
} from "../event-manager";
import {
	BREAKPOINT_CHANGE
} from "../../02-const/event-names";

class Breakpoint {

	constructor() {
		/**
		 * Holds the initialized state of the util
		 * @type {Boolean}
		 */
		this.isInitialized = false;

		/**
		 * Current breakpoint
		 * @type {String}
		 */
		this.currentBreakpoint = '';

		/**
		 * The public interface object
		 * @type {Object}
		 */
		this.publicInterface;

		/**
		 * Used as references to the timer
		 * and the delay in ms
		 */
		this.resizeTimerDelay = 200;
		this.resizeTimer;

		/**
         * Element to check the content property on
         * @type {Object}
         */
		this.$head = $('head');

		/**
			* The name for the desk breakpoint
			* @type {String}
			*/
		this.deskBreakpoint = 'desk';

		/**
			* The name for the lap breakpoint
			* @type {String}
			*/
		this.lapBreakpoint = 'lap';

		/**
			* The name for the palm breakpoint
			* @type {String}
			*/
		this.palmBreakpoint = 'palm';

		/**
			* List of available breakpoints as defined in the SCSS
			* @type {Array}
			*/
		this.availableBreakpoints = [
			this.deskBreakpoint,
			this.lapBreakpoint,
			this.palmBreakpoint
		];

		/**
			* The css property to use as placeholder
			* @type {String}
			*/
		this.cssProperty = 'font-family';

		/**
			* Default fallback breakpoint
			* @type {String}
			*/
		this.fallbackBreakpoint = this.deskBreakpoint;

		this.registerHandleResize = e => this.onResizeUpdateBreakpoint(e);

		this.init();
	}

	/**
	 * 
	 */
	setBindHandlers() {
		const $window = $(window);

		$window.on('resize', this.registerHandleResize);
		$window.on('breakpointChange', function (e, currentBreakpoint, oldBreakpoint) {
			$('html').addClass(currentBreakpoint).removeClass(oldBreakpoint);
		});

	}

	/**
	 * A helper function that makes removes quotes from a string
	 * @param {String} string The string to strip quotes off
	 */
	removeQuotes(string) {
		return string.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
	}

	/**
	 * Check if the given breakpoint is valid
	 * @param {String} breakpoint The name of the breakpoint
	 * @function validateBreakpoint
	 */
	validateBreakpoint(breakpoint) {
		if (
			breakpoint &&
			this.availableBreakpoints.join(',').indexOf(breakpoint) !== -1
		) {
			return true;
		}

		return false;
	}

	/**
	 * Set the breakpoint to a the given value
	 * @param {String} breakpoint The name of the breakpoint
	 * @function setBreakpoint
	 */
	setBreakpoint(breakpoint) {
		var oldBreakpoint = this.currentBreakpoint;

		this.currentBreakpoint = this.validateBreakpoint(breakpoint)
			? breakpoint
			: this.fallbackBreakpoint;

		// Make sure we only trigger the event after resize, not on init
		if (
			oldBreakpoint !== this.currentBreakpoint &&
			this.isInitialized === true
		) {
			publish(BREAKPOINT_CHANGE, [this.currentBreakpoint, oldBreakpoint]);
		
			$(window).trigger(
				'breakpointChange',
				[
					this.currentBreakpoint,
					oldBreakpoint
				]
			);
		}
	}

	/**
	 * Update the breakpoint if a resize is finished
	 * @function updateBreakpoint
	 */
	updateBreakpoint() {
		// Reason we strip the quotes is because of browser returning
		// inconsistent values, some wrapped in quotes and some not
		var breakpoint = this.removeQuotes(this.$head.css(this.cssProperty));
		this.setBreakpoint(breakpoint);
	}

	/**
	 * Handle the resize event in a time queue to prevent overload
	 * @function onResizeUpdateBreakpoint
	 */
	onResizeUpdateBreakpoint(e) {
		if (this.resizeTimer) {
			clearTimeout(this.resizeTimer);
		}
		this.resizeTimer = setTimeout(() => {
			this.updateBreakpoint();
		}, this.resizeTimerDelay);
	}

	/**
	 * Get the current breakpoint
	 * @function getBreakpoint
	 */
	getBreakpoint() {
		return this.currentBreakpoint;
	}

	/**
	 * Check if the current breakpoint is "desk"
	 * @return {Boolean} true if current breakpoint is "desk" else false
	 */
	isDesk() {
		return this.getBreakpoint() === this.deskBreakpoint;
	}

	/**
	 * Check if the current breakpoint is "lap"
	 * @return {Boolean} true if current breakpoint is "lap" else false
	 */
	isLap() {
		return this.getBreakpoint() === this.lapBreakpoint;
	}

	/**
	 * Check if the current breakpoint is "palm"
	 * @return {Boolean} true if current breakpoint is "palm" else false
	 */
	isPalm() {
		return this.getBreakpoint() === this.palmBreakpoint;
	}

	/**
	 * Initialize the util
	 * @function init
	 */
	init() {
		$('html').addClass(this.getBreakpoint());
		this.setBindHandlers();
		this.updateBreakpoint();
		// Mark the util as initialized
		this.isInitialized = true;
	}
}

export default (new Breakpoint);
